import { Linking, Platform } from 'react-native';

import Share from 'react-native-share';

import { PlaybackTypes } from 'store/railsBuilder/reducer.types';

import getAppName from 'utils/deeplinks/getAppName';
import { openMarketLink } from 'utils/deeplinks/openMarketLink';
import setFlagReturnToLauncher from 'utils/deeplinks/setFlagReturnToLauncher';

import { OnUavAnalyticsProps } from 'components/Ribbon/types';

type Props = {
    deeplinkProviderId: string;
    providerResourceId: string;
    itemId: string;
    deepLinkid: string;
    appleAppId: string;
    androidMobileBundleId: string;
    url: string;
    marketLink: string;
    playbackType: PlaybackTypes | undefined;
} & OnUavAnalyticsProps;

export default async function handleOpenDeeplink({
    itemId,
    deepLinkid,
    onThirdPartyAppStart,
    onDeepLinkTriggered,
    deeplinkProviderId,
    providerResourceId,
    androidMobileBundleId,
    appleAppId,
    url,
    marketLink,
    playbackType,
}: Props) {
    onDeepLinkTriggered?.({
        id: itemId,
        deeplinkProviderId,
        providerResourceId,
        deepLinkid,
        playbackType,
    });

    const appName = await getAppName(androidMobileBundleId, appleAppId);

    try {
        const canOpen = await Linking.canOpenURL(url);
        let isInstalled = false;

        if (Platform.OS === 'android') {
            const appInstalledResult = await Share.isPackageInstalled(
                androidMobileBundleId,
            );
            isInstalled = appInstalledResult.isInstalled;
        }

        // ! ardmediathek does not have app in play market or app store, it is a PWA
        // ! when ardmediathek is not installed, browser should be opened
        // ! app installation is handled by ardmediathek web site

        if (Platform.select({ default: canOpen, android: isInstalled })) {
            await Linking.openURL(url);

            onThirdPartyAppStart?.({
                appReference: url,
                deeplinkProviderId,
                deepLinkid,
                providerResourceId,
                appName,
                playbackType,
            });

            setFlagReturnToLauncher(appName);
        } else {
            openMarketLink(marketLink, appName);
        }
    } catch (error) {
        // ! On IOS unsupported scheme triggers error
        openMarketLink(marketLink, appName);
    }
}
